(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  class ReferenceCart extends HTMLElement {
    connectedCallback() {
      this.root = this.dataset.root || '/';
      this.status = this.querySelector('[data-cart-status]');
      this.pending = false;
      this.addEventListener('click', (event) => {
        const clearButton = event.target.closest('[data-cart-clear]');
        if (clearButton) {
          this.clear();
          return;
        }
        const button = event.target.closest('[data-quantity-button]');
        if (!button) return;
        const input = this.querySelector(`[data-quantity-input][data-line="${button.dataset.line}"]`);
        if (!input) return;
        const quantity = Math.min(6, Math.max(0, Number(input.value) + Number(button.dataset.delta)));
        if (quantity === Number(input.value)) return;
        input.value = String(quantity);
        this.change(button.dataset.line, quantity);
      });
      this.querySelectorAll('[data-quantity-input]').forEach((input) => input.addEventListener('change', () => {
        input.value = String(Math.min(6, Math.max(0, Number(input.value) || 0)));
        this.change(input.dataset.line, Number(input.value));
      }));
      const email = this.querySelector('[data-cart-email]');
      email?.addEventListener('change', () => this.saveEmail(email));
    }

    async change(line, quantity) {
      if (this.pending) return;
      this.pending = true;
      this.toggleQuantityButtons(true);
      if (this.status) this.status.textContent = 'Mise à jour du panier…';
      try {
        const response = await fetch(`${this.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity })
        });
        if (!response.ok) throw new Error('cart-change');
        window.location.reload();
      } catch (error) {
        this.pending = false;
        this.toggleQuantityButtons(false);
        if (this.status) this.status.textContent = 'La quantité n’a pas pu être mise à jour. Réessayez.';
      }
    }

    async saveEmail(input) {
      if (!input.value || !input.checkValidity()) return;
      try {
        await fetch(`${this.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'E-mail de réception des billets': input.value } })
        });
      } catch (error) {
        if (this.status) this.status.textContent = 'L’adresse e-mail sera enregistrée au passage de la commande.';
      }
    }

    async clear() {
      if (this.pending) return;
      this.pending = true;
      if (this.status) this.status.textContent = 'Vidage du panier…';
      try {
        const response = await fetch(`${this.root}cart/clear.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('cart-clear');
        window.location.reload();
      } catch (error) {
        this.pending = false;
        if (this.status) this.status.textContent = 'Le panier n’a pas pu être vidé. Réessayez.';
      }
    }

    toggleQuantityButtons(disabled) {
      this.querySelectorAll('[data-quantity-button]').forEach((button) => { button.disabled = disabled; });
    }
  }

  if (!customElements.get('reference-cart')) customElements.define('reference-cart', ReferenceCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["queue-screen"] && !Shopify.designMode) return;
  try {
    
  class QueueScreen extends HTMLElement {
    connectedCallback() {
      this.progress = this.querySelector('[data-queue-progress]');
      this.fill = this.querySelector('[data-queue-fill]');
      this.percent = this.querySelector('[data-queue-percent]');
      this.status = this.querySelector('[data-queue-status]');
      this.target = this.getTarget();
      this.duration = Math.max(1000, Number(this.dataset.duration) || 8000);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.duration = Math.min(this.duration, 1800);
      this.startedAt = performance.now();
      this.frame = requestAnimationFrame((time) => this.tick(time));
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.redirectTimer);
    }

    getTarget() {
      const raw = new URLSearchParams(window.location.search).get('destination') || '/pages/billetterie';
      const candidate = new URL(raw, window.location.origin);
      const allowed = ['/pages/billetterie', '/pages/hospitalites'];
      if (candidate.origin !== window.location.origin || !allowed.some((path) => candidate.pathname.endsWith(path))) {
        return '/pages/billetterie';
      }
      return `${candidate.pathname}${candidate.search}${candidate.hash}`;
    }

    tick(time) {
      const linear = Math.min(1, (time - this.startedAt) / this.duration);
      const eased = 1 - Math.pow(1 - linear, 1.35);
      const value = linear === 1 ? 100 : Math.min(99, Math.floor(eased * 100));
      this.fill.style.width = `${value}%`;
      this.percent.innerHTML = `${value}&nbsp;%`;
      this.progress.setAttribute('aria-valuenow', String(value));
      if (value >= 72) this.status.textContent = this.dataset.progressMessage;
      if (linear < 1) {
        this.frame = requestAnimationFrame((nextTime) => this.tick(nextTime));
        return;
      }
      this.status.textContent = this.dataset.readyMessage;
      if (window.Shopify && window.Shopify.designMode) return;
      this.redirectTimer = setTimeout(() => window.location.assign(this.target), 450);
    }
  }

  if (!customElements.get('queue-screen')) customElements.define('queue-screen', QueueScreen);

  } catch(e) { console.error(e); }
})();
})();
